<div class="meeting-session-container">
    <!-- Header -->
    <div class="meeting-session-header d-flex justify-content-between align-items-center mb-4">
        <div>
            <h4 class="mb-1">{{ meetingTitle }}</h4>
            <small class="text-muted">Meeting ID: {{ meetingId }}</small>
            <small class="text-muted ms-2" *ngIf="startedBy">Started by: {{ startedBy }}</small>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="closeSession()" aria-label="Close session">
            <i class="fas fa-times"></i> Close
        </button>
    </div>

    <!-- Meeting Content Area -->
    <div class="row mb-4">
        <!-- Main Content -->
        <div class="col-12 col-md-8">
            <div class="meeting-content-section">
                <h5 class="mb-3">Meeting Details</h5>
                <div class="meeting-info p-3 bg-light rounded" *ngIf="meetingData">
                    <pre>{{ meetingData | json }}</pre>
                </div>
                <div class="alert alert-info" *ngIf="!meetingData">
                    No additional meeting data available.
                </div>
            </div>
        </div>

        <!-- Connected Users -->
        <div class="col-12 col-md-4">
            <div class="connected-users-section">
                <h5 class="mb-3">Connected Users</h5>
                <div class="users-list">
                    <div class="user-item p-2 mb-2 bg-light rounded" *ngFor="let user of connectedUsers; trackBy: trackByUserName">
                        <i class="fas fa-user-circle me-2"></i>
                        {{ user }}
                    </div>
                    <div class="user-item p-2 mb-2 bg-light rounded">
                        <i class="fas fa-user-circle me-2"></i>
                        {{ currentUserName }} (You)
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Chat Section -->
    <div class="chat-section">
        <h5 class="mb-3">Meeting Chat</h5>
        <div class="chat-messages p-3 bg-light rounded mb-3" style="height: 300px; overflow-y: auto;">
            <div *ngFor="let message of messages; trackBy: trackByMessageId" class="message-item mb-3">
                <div class="message-header d-flex justify-content-between mb-1">
                    <strong [class.text-primary]="message.userId === currentUserId" 
                            [class.text-muted]="message.userId === 'system'">
                        {{ message.userName }}
                    </strong>
                    <small class="text-muted">{{ message.timestamp | date:'short' }}</small>
                </div>
                <div class="message-content" 
                     [class.text-end]="message.userId === currentUserId"
                     [class.text-muted]="message.userId === 'system'">
                    {{ message.message }}
                </div>
            </div>
            <div *ngIf="messages.length === 0" class="text-center text-muted">
                No messages yet. Start the conversation!
            </div>
        </div>
        
        <!-- Message Input -->
        <div class="message-input d-flex gap-2">
            <input 
                type="text" 
                class="form-control" 
                [(ngModel)]="newMessage"
                (keyup.enter)="sendMessage()"
                placeholder="Type your message...">
            <button 
                type="button" 
                class="btn btn-primary"
                (click)="sendMessage()"
                [disabled]="!newMessage.trim()">
                <i class="fas fa-paper-plane"></i> Send
            </button>
        </div>
    </div>
</div>

